var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fs-13" },
    [
      _vm.recipientData && _vm.recipientData.language_code
        ? _c("div", { staticClass: "colGrid-2 mb-10" }, [
            _c("span", [_c("b", [_vm._v(_vm._s(_vm.$t("language")))])]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.$t(_vm.recipientData.language_code)))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.recipientData && _vm.recipientData.preferred_invoicing_channel
        ? _c("div", { staticClass: "colGrid-2 mb-10" }, [
            _c("span", [
              _c("b", [_vm._v(_vm._s(_vm.$t("preferred_invoicing_channel")))])
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                _vm._s(_vm.$t(_vm.recipientData.preferred_invoicing_channel))
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.activatedEndpoints, function(endpoint, index) {
        return _c(
          "div",
          { key: index, staticClass: "colGrid-3 mb-10" },
          [
            _c(
              "div",
              [
                endpoint.channel == `EMAIL`
                  ? _c("span", [_c("b", [_vm._v(_vm._s(_vm.$t("email")))])])
                  : endpoint.channel == `PHONE`
                  ? _c("span", [_c("b", [_vm._v(_vm._s(_vm.$t("phone")))])])
                  : endpoint.channel == `MAIL`
                  ? _c("span", [_c("b", [_vm._v(_vm._s(_vm.$t("address")))])])
                  : _vm._e(),
                _vm._v(" "),
                endpoint.endpoint_details.invoicing
                  ? _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content:
                            _vm.$t("main_contacts.invoicing") +
                            (endpoint.endpoint_details.invoicing_type
                              ? " (" +
                                endpoint.endpoint_details.invoicing_type +
                                ")"
                              : ""),
                          placement: "top"
                        }
                      },
                      [_c("i", { staticClass: "el-icon-coin" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                endpoint.endpoint_details.dunning
                  ? _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content:
                            _vm.$t("main_contacts.dunning") +
                            (endpoint.endpoint_details.dunning_type
                              ? " (" +
                                endpoint.endpoint_details.dunning_type +
                                ")"
                              : ""),
                          placement: "top"
                        }
                      },
                      [_c("i", { staticClass: "el-icon-bell" })]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                endpoint.channel == `EMAIL`
                  ? [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(endpoint.endpoint) + "\n\t\t\t"
                      )
                    ]
                  : endpoint.channel == `PHONE`
                  ? [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(endpoint.endpoint) + "\n\t\t\t"
                      )
                    ]
                  : endpoint.channel == `MAIL`
                  ? [
                      _vm.address(endpoint)
                        ? [
                            _vm.address(endpoint).company_name
                              ? _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.address(endpoint).company_name
                                      ) +
                                      "\n\t\t\t\t\t"
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.address(endpoint).street_name
                              ? _c(
                                  "div",
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.address(endpoint).street_name
                                        ) +
                                        "\n\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.address(endpoint).street_number
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    ),
                                    _vm.address(endpoint).post_box
                                      ? [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t" +
                                              _vm._s(_vm.$t("post_box")) +
                                              " " +
                                              _vm._s(
                                                _vm.address(endpoint).post_box
                                              ) +
                                              "\n\t\t\t\t\t\t"
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm.address(endpoint).street_name_number_box
                              ? _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.address(endpoint)
                                          .street_name_number_box
                                      ) +
                                      "\n\t\t\t\t\t"
                                  )
                                ])
                              : _c("div", [
                                  _vm._v("\n\t\t\t\t\t \n\t\t\t\t\t")
                                ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.address(endpoint).zip_code) +
                                  "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.address(endpoint).city) +
                                  "\n\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.address(endpoint).iso_country_code
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ])
                          ]
                        : [_c("div", [_vm._v("\n\t\t\t\t\t \n\t\t\t\t\t")])]
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.endpointSelectable
                  ? _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: _vm.$t("shared.select_this_endpoint"),
                          placement: "top"
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "clipboard",
                            on: {
                              click: function($event) {
                                return _vm.handleSelectEndpoint(endpoint)
                              }
                            }
                          },
                          [_c("i", { staticClass: "el-icon-aim" })]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "el-dropdown",
              { staticStyle: { height: "20px" }, attrs: { size: "mini" } },
              [
                _c("span", { staticClass: "el-dropdown-link" }, [
                  _c("i", { staticClass: "el-icon-more" })
                ]),
                _vm._v(" "),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  [
                    _c(
                      "el-dropdown-item",
                      { attrs: { disabled: !_vm.allowEdit } },
                      [
                        !_vm.allowEdit
                          ? _c("i", { staticClass: "el-icon-lock" })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            on: {
                              click: function($event) {
                                return _vm.handleEditChannelEndpoint(endpoint)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("edit")))]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    endpoint.deactivated_at === null
                      ? _c("el-dropdown-item", { attrs: { divided: "" } }, [
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.handleDeactivate(
                                    endpoint.reference
                                  )
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("deactivate")) + " ")]
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.risoltoEndpoints.length > 0
        ? _c("h4", { staticClass: "mt-20 mb-10" }, [
            _vm._v(_vm._s(_vm.$t("origin_risolto")))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.risoltoEndpoints, function(endpoint, index) {
        return _c(
          "div",
          { key: `r-${index}`, staticClass: "colGrid-3 mb-10" },
          [
            _c(
              "div",
              [
                endpoint.channel == `EMAIL`
                  ? _c("span", [_c("span", [_vm._v(_vm._s(_vm.$t("email")))])])
                  : endpoint.channel == `PHONE`
                  ? _c("span", [_c("span", [_vm._v(_vm._s(_vm.$t("phone")))])])
                  : endpoint.channel == `MAIL`
                  ? _c("span", [
                      _c("span", [_vm._v(_vm._s(_vm.$t("address")))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                endpoint.endpoint_details.invoicing
                  ? _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content:
                            _vm.$t("main_contacts.invoicing") +
                            (endpoint.endpoint_details.invoicing_type
                              ? " (" +
                                endpoint.endpoint_details.invoicing_type +
                                ")"
                              : ""),
                          placement: "top"
                        }
                      },
                      [_c("i", { staticClass: "el-icon-coin" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                endpoint.endpoint_details.dunning
                  ? _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content:
                            _vm.$t("main_contacts.dunning") +
                            (endpoint.endpoint_details.dunning_type
                              ? " (" +
                                endpoint.endpoint_details.dunning_type +
                                ")"
                              : ""),
                          placement: "top"
                        }
                      },
                      [_c("i", { staticClass: "el-icon-bell" })]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                endpoint.channel == `EMAIL`
                  ? [_c("span", [_vm._v(_vm._s(endpoint.endpoint))])]
                  : endpoint.channel == `PHONE`
                  ? [_c("span", [_vm._v(_vm._s(endpoint.endpoint))])]
                  : endpoint.channel == `MAIL`
                  ? [
                      _vm.address(endpoint)
                        ? [
                            _vm.address(endpoint).company_name
                              ? _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.address(endpoint).company_name
                                      ) +
                                      "\n\t\t\t\t\t"
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.address(endpoint).street_name
                              ? _c(
                                  "div",
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.address(endpoint).street_name
                                        ) +
                                        "\n\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.address(endpoint).street_number
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    ),
                                    _vm.address(endpoint).post_box
                                      ? [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t" +
                                              _vm._s(_vm.$t("post_box")) +
                                              " " +
                                              _vm._s(
                                                _vm.address(endpoint).post_box
                                              ) +
                                              "\n\t\t\t\t\t\t"
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm.address(endpoint).street_name_number_box
                              ? _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.address(endpoint)
                                          .street_name_number_box
                                      ) +
                                      "\n\t\t\t\t\t"
                                  )
                                ])
                              : _c("div", [
                                  _vm._v("\n\t\t\t\t\t \n\t\t\t\t\t")
                                ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.address(endpoint).zip_code) +
                                  "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.address(endpoint).city) +
                                  "\n\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.address(endpoint).iso_country_code
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ])
                          ]
                        : [_c("div", [_vm._v("\n\t\t\t\t\t \n\t\t\t\t\t")])]
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.endpointSelectable
                  ? _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: _vm.$t("shared.select_this_endpoint"),
                          placement: "top"
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "clipboard",
                            on: {
                              click: function($event) {
                                return _vm.handleSelectEndpoint(endpoint)
                              }
                            }
                          },
                          [_c("i", { staticClass: "el-icon-aim" })]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "el-dropdown",
              { staticStyle: { height: "20px" }, attrs: { size: "mini" } },
              [
                _c("span", { staticClass: "el-dropdown-link" }, [
                  _c("i", { staticClass: "el-icon-more" })
                ]),
                _vm._v(" "),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  [
                    _c(
                      "el-dropdown-item",
                      { attrs: { disabled: !_vm.allowEdit } },
                      [
                        !_vm.allowEdit
                          ? _c("i", { staticClass: "el-icon-lock" })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            on: {
                              click: function($event) {
                                return _vm.handleEditChannelEndpoint(endpoint)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("edit")))]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    endpoint.deactivated_at === null
                      ? _c("el-dropdown-item", { attrs: { divided: "" } }, [
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.handleDeactivate(
                                    endpoint.reference
                                  )
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("deactivate")) + " ")]
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticClass: "button",
          attrs: { disabled: !_vm.allowEdit, type: "text" },
          on: {
            click: function($event) {
              return _vm.handleAddChannelEndpoint()
            }
          }
        },
        [
          _c("i", { staticClass: "el-icon-plus" }),
          _vm._v(" " + _vm._s(_vm.$t("add_channel_endpoint")) + "\n\t\t"),
          !_vm.allowEdit
            ? _c("span", [
                _vm._v(" "),
                _c("i", { staticClass: "el-icon-lock" })
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.allowEdit
        ? _c("channel-endpoint-dialog", {
            attrs: {
              participant: _vm.selectedParticipantStore,
              recipient: _vm.recipient,
              "legal-entity": _vm.legalEntity,
              endpoint: _vm.channelEndpointDialogEndpoint,
              visible: _vm.channelEndpointDialogVisible,
              "dialog-close": () => {
                _vm.channelEndpointDialogVisible = false
                _vm.channelEndpointDialogEndpoint = null
              }
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }